
define('text!templates/modules/calendar/animated-session/tags/edit/placeholder/tag-exercise-placeholder.html',[],function () { return '<div class="add-tag-exercise">\n    <div class="add-placeholder">\n        <span class="sl-icon-plus"></span> {{#t}}calendar:Click or drag & drop to add an exercise{{/t}}\n    </div>\n</div>\n';});

